import { Button, Col, Form, Grid, Input, Modal, Row, Upload } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import PhotoButton from "../../../qforms/standard_elements/PhotoButton";
import TextArea from "antd/es/input/TextArea";
import log from "cslog";
import {
    useCreateItem,
    useUpdateItem,
} from "../../../_actions/mutations/items";

const { useBreakpoint } = Grid;

function AddBrandPersonal({ show, setShow, initialValues = {} }) {
    const [form] = Form.useForm();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const mutationCreate = useCreateItem("qdb_person", () => setShow(false));
    const mutationUpdate = useUpdateItem("qdb_person", initialValues?.id, () =>
        setShow(false)
    );

    const closeModal = () => {
        // form.resetFields();
        setShow(false);
    };

    const is_update = !!initialValues?.id;

    const addPerson = (values) => {
        log.d(values, "Person values");
        if (!!initialValues?.id) {
            log.p("Updating person");
            mutationUpdate.mutate({
                ...values,
                full_name: `${values.first_name} ${values.last_name}`,
            });
        } else {
            log.p("Creating person");
            mutationCreate.mutate({
                ...values,
                full_name: `${values.first_name} ${values.last_name}`,
            });
        }
    };

    log.d(initialValues, "Initial Values");

    return (
        <Fragment>
            <Modal
                title={`${is_update ? "Update" : "Add new"} pesonal brand`}
                open={show}
                width={isMobile ? "100%" : 520}
                style={
                    isMobile
                        ? { top: 0, margin: 0, maxWidth: "100vw", padding: 0 }
                        : {}
                }
                styles={{
                    body: { padding: isMobile ? "16px" : "24px" },
                    content: isMobile ? { borderRadius: 0 } : {},
                }}
                onOk={() => {}}
                confirmLoading={false}
                onCancel={closeModal}
                footer={[
                    <Button
                        key="cancel"
                        size={isMobile ? "large" : "middle"}
                        onClick={closeModal}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        size={isMobile ? "large" : "middle"}
                        onClick={() => form.submit()}
                        loading={
                            mutationCreate.isLoading || mutationUpdate.isLoading
                        }
                    >
                        {is_update ? "Update" : "Create"}
                    </Button>,
                ]}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={addPerson}
                    initialValues={initialValues}
                >
                    <Row gutter={[12, isMobile ? 0 : 12]}>
                        <Col xs={24} sm={12}>
                            <Form.Item label="First Name" name="first_name">
                                <Input size={isMobile ? "large" : "middle"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item label="Last Name" name="last_name">
                                <Input size={isMobile ? "large" : "middle"} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Photo" name="photo">
                        <PhotoButton
                            field={{
                                collection: "qdb_person",
                                field: "photo",
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="Bio" name="bio">
                        <TextArea
                            rows={3}
                            size={isMobile ? "large" : "middle"}
                        />
                    </Form.Item>
                    <Row gutter={[12, isMobile ? 0 : 12]}>
                        <Col xs={24} sm={12}>
                            <Form.Item label="Email" name="email">
                                <Input size={isMobile ? "large" : "middle"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item label="Mobile" name="mobile">
                                <Input size={isMobile ? "large" : "middle"} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Website" name="website">
                        <Input size={isMobile ? "large" : "middle"} />
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>
    );
}

export default AddBrandPersonal;
